// CustomerCard.jsx
import React from 'react';

export default function CardComponent({title, blurb, imageURL, imageALT, ctaURL, publishedDate}) {
    return (
        <div className="w-full rounded-lg overflow-hidden">
            <img
                alt={imageALT}
                src={imageURL}
                style={{width: '100%', height: '300px', objectFit: 'cover', objectPosition: 'center'}}
                className="rounded-xl"
            />
            <div className="pt-3 pb-4 pr-2">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{title}</h3>
                <p className="text-gray-600 text-sm mb-4">
                    {blurb}
                </p>
                {
                    Boolean(ctaURL) &&
                    <div className="flex items-center justify-between text-sm">
                        {publishedDate && <span className="text-gray-500">⏳ {publishedDate}</span>}
                        <a href={ctaURL} className="text-blue-600 hover:text-blue-800 font-medium">
                            Read More &gt;
                        </a>
                    </div>
                }
            </div>
        </div>
    );
};

